module.exports = __webpack_public_path__ + "static/img_17-6b3c381dcb3ed4400491986d20d8c924.png";